import React from 'react';
import {
  BottomNavigation,
  BottomNavigationAction,
  Paper,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import PlaceIcon from '@mui/icons-material/Place';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import MapIcon from '@mui/icons-material/Map';
import { useNavigate, useLocation } from 'react-router-dom';
import { ROUTES } from '../../constants';

const navItems = [
  { label: 'Home', path: ROUTES.HOME, icon: <HomeIcon /> },
  { label: 'Places', path: ROUTES.PLACES, icon: <PlaceIcon /> },
  { label: 'Experiences', path: ROUTES.EXPERIENCES, icon: <EmojiEventsIcon /> },
  { label: 'Map', path: ROUTES.MAP_VIEW, icon: <MapIcon /> },
];

/**
 * Bottom navigation for mobile devices
 */
export const BottomNav: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const location = useLocation();

  if (!isMobile) {
    return null;
  }

  const currentPathIndex = navItems.findIndex((item) => item.path === location.pathname);

  return (
    <Paper
      sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000 }}
      elevation={3}
    >
      <BottomNavigation
        value={currentPathIndex !== -1 ? currentPathIndex : 0}
        onChange={(_event, newValue) => {
          navigate(navItems[newValue].path);
        }}
        showLabels
      >
        {navItems.map((item) => (
          <BottomNavigationAction
            key={item.path}
            label={item.label}
            icon={item.icon}
          />
        ))}
      </BottomNavigation>
    </Paper>
  );
};
